'use client';

import Button, { type ButtonVariant, ButtonVariants, BUTTON_STATES } from '@pixum/button';
import { CheckMarkRound } from '@pixum/svg-icon';

interface ButtonWithAddCreationProductToCartProps {
  isBusy: boolean;
  isEffectivelyAdded: boolean;
  isDisabled: boolean;
  constants: Record<string, string>;
  variant?: ButtonVariant;
  onClick: () => void;
}

export function ButtonWithAddCreationProductToCart({
  isBusy,
  isEffectivelyAdded,
  isDisabled,
  constants,
  variant = ButtonVariants.TERTIARY,
  onClick
}: ButtonWithAddCreationProductToCartProps) {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={isDisabled}
      isBusy={isBusy}
      state={isEffectivelyAdded ? BUTTON_STATES.SUCCESS : BUTTON_STATES.DEFAULT}
      leadingIcon={isEffectivelyAdded ? <CheckMarkRound /> : undefined}
    >
      {isEffectivelyAdded ? constants['i18n_added'] : constants['i18n_add_to_cart']}
    </Button>
  );
}
